import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import RmpSignInFormBase from "@rmp/core/components/form/RmpSignInFormBase.vue";
import { useI18n } from "vue-i18n-composable";
import { useRoute } from "vue-router/composables";
import { useColors } from "@rmp/core/composables/useColors";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useForm } from "@rmp/core/composables/useForm";
import { usePage } from "@rmp/core/composables/usePage";
import { useResetPasswordStore } from "@rmp/id/stores/resetPassword";
import { prepareConfirmedPasswordRule, preparePasswordRule, requiredRule } from "@rmp/core/utils/validation";
import { AuthPageModeType } from "@rmp/core/types/authorization/authPageModeType";
import { formatSecondsLeft } from "@rmp/core/utils/dates";
import { RouteNames } from "@rmp/id/router/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpResetPassword',
  setup(__props) {

const { tc, t } = useI18n();
const route = useRoute();
const { colors } = useColors();

const useStore = useResetPasswordStore;
const store = useStore();
const { password, mode } = storeToRefs(store);

const title = computed(() => {
	switch (mode.value) {
		case AuthPageModeType.INITIAL:
			return tc("titles.resetPassword");
		case AuthPageModeType.SUCCESS:
			return tc("titles.resetPasswordSuccess");
	}
});

const isPasswordHidden = ref(true);
const confirmedPassword = ref("");
const isConfirmedPasswordHidden = ref(true);

const validation = {
	login: [requiredRule()],
	password: [requiredRule(), preparePasswordRule()],
	confirmedPassword: [requiredRule(), prepareConfirmedPasswordRule(() => password.value)]
};

const {
	form,
	formStateLoading,
	formReadonly,
	formDisabled,
	formSaving,
	formValid,
	submit
} = useForm({ useStore }, true);

const { initialized, loading } = usePage({ useStore });

return { __sfc: true,tc, t, route, colors, useStore, store, password, mode, title, isPasswordHidden, confirmedPassword, isConfirmedPasswordHidden, validation, form, formStateLoading, formReadonly, formDisabled, formSaving, formValid, submit, initialized, loading, RmpText, RmpBtn, RmpTextField, RmpSignInFormBase, AuthPageModeType, formatSecondsLeft, RouteNames }
}

})